function police(string) {
var i = "Write a comment...";
if (string == null) {
i = "Please login to enter";

}
return i;
}


function police_2(){
	  var i = sessionStorage.getItem("i_name");
if (i == null) {  
  console.log("apalah");
police();
}
 }

export function police_3(police,input_id){
		  var p = sessionStorage.getItem("i_name");
		  console.log(p+"moment of truth kali");
if(p != null){  
document.getElementById(police).style.display = "none";
}else{
document.getElementById(input_id).style.display = "none";
document.getElementById(police).style.display = "block";
}
}